import { Empty, Form, Select, Spin } from "antd";
import _ from "lodash";
import { CompanyLine } from "model/CompanyLine";
import { TimetableTripRoute } from "model/TimetableTripRoute";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CompanyLineState } from "store/companyLine/reducer";
import { createCompanyLineAction } from "store/companyLine/store";
import { useAction } from "store/store";
import { TimetableState } from "store/timetable/reducer";
import { createTimetableTripRouteAction } from "store/timetable/store";

type State = {
    companyLine?: CompanyLineState,
    timetable?: TimetableState,
}

const Timetable: React.FC = () => {
    const dispatch = useDispatch<any>();
    const action = useAction(createCompanyLineAction());
    const timetableAction = useAction(createTimetableTripRouteAction());
    const [selectLine, setSelectLine] = useState<CompanyLine>();
    const companyLineState = useSelector((state: State) => state.companyLine);
    const timetableState = useSelector((state: State) => state.timetable);
    const [firstLoading, setFirstLoading] = useState<boolean>(true);

    useEffect(() => {
        dispatch(action.getCompanyLines());
    }, [dispatch, action])

    useEffect(() => {
        if (selectLine != null) {
            dispatch(timetableAction.getTimetableTripRoute(selectLine.id)).then(() => setFirstLoading(false));
        }
    }, [dispatch, timetableAction, selectLine])

    return <div>
        <Form
            name="basic"
            initialValues={{ remember: true }}
            autoComplete="off"
        >
            <Form.Item
                label="Linha"
                name="linha"
                style={{ maxWidth: 400 }}
            >
                <Select onChange={(value) => setSelectLine(companyLineState?.list.find(a => a.id === value))} loading={companyLineState?.loading} size="large">
                    {_.orderBy(companyLineState?.list, (x: any) => x.line.lineCode).map((x: any) => <Select.Option key={x.id} value={x.id}>
                        <span className="line-code">{x.line.lineCode}</span>{x.line.description}
                    </Select.Option>)}
                </Select>
            </Form.Item>
        </Form>
        <div className="select-line">
            {selectLine && <div className="title"> <span className="line-code">{selectLine?.line.lineCode}</span>{selectLine?.line.description}</div>}
        </div>
        <Spin spinning={timetableState?.loading}>
            <div className="trips-schedule">
                {(timetableState?.list != null && timetableState.list.length > 0) &&
                    timetableState.list.map(item => <TimetableTripSchedule item={item} />)}
                {(timetableState?.list != null && timetableState.list.length === 0 && !firstLoading && selectLine != null) && <Empty />}
            </div>
        </Spin>
    </div>
}

type Props = {
    item: TimetableTripRoute
}

const TimetableTripSchedule: React.FC<Props> = (props) => {
    return <div className="trip-schedule">
        <div className="trip-schedule-title">{props.item.name}</div>
        <hr />
        {props.item.typeDays.map((typeDay, i) => {
            var htmlTemp: JSX.Element = <></>;
            if (typeDay.typeDay === 'U') {
                htmlTemp = <BusinessDay key={1} />
            } else if (typeDay.typeDay === 'S') {
                htmlTemp = <Saturday key={2} />
            } else if (typeDay.typeDay === 'DF') {
                htmlTemp = <SundayHoliday key={3} />
            }
            return <div>
                {i > 0 && <hr className="hr-hours" />}
                {htmlTemp}
                <div className="hours">
                    {typeDay.hours.map((hour, i) => <div key={i}>{hour}</div>)}
                </div>
            </div>
        })}

    </div>
}

const BusinessDay: React.FC = () => {
    return <div className="days">
        <div className="days-title">Dias Úteis</div>
        <div className="days-active">
            <div>
                SEG
            </div>
        </div>
        <div className="days-active">
            <div>
                TER
            </div>
        </div>
        <div className="days-active">
            <div>
                QUA
            </div>
        </div>
        <div className="days-active">
            <div>
                QUI
            </div>
        </div>
        <div className="days-active">
            <div>
                SEX
            </div>
        </div>
        <div className="days-inactive">
            <div>
                SAB
            </div>
        </div>
        <div className="days-inactive">
            <div>
                DOM
            </div>
        </div>
    </div>
}

const Saturday: React.FC = () => {
    return <div className="days">
        <div className="days-title">Sábados</div>
        <div className="days-inactive">
            <div>
                SEG
            </div>
        </div>
        <div className="days-inactive">
            <div>
                TER
            </div>
        </div>
        <div className="days-inactive">
            <div>
                QUA
            </div>
        </div>
        <div className="days-inactive">
            <div>
                QUI
            </div>
        </div>
        <div className="days-inactive">
            <div>
                SEX
            </div>
        </div>
        <div className="days-active">
            <div>
                SAB
            </div>
        </div>
        <div className="days-inactive">
            <div>
                DOM
            </div>
        </div>
    </div>
}

const SundayHoliday: React.FC = () => {
    return <div className="days">
        <div className="days-title">Domingos e Feriados</div>
        <div className="days-inactive">
            <div>
                SEG
            </div>
        </div>
        <div className="days-inactive">
            <div>
                TER
            </div>
        </div>
        <div className="days-inactive">
            <div>
                QUA
            </div>
        </div>
        <div className="days-inactive">
            <div>
                QUI
            </div>
        </div>
        <div className="days-inactive">
            <div>
                SEX
            </div>
        </div>
        <div className="days-inactive">
            <div>
                SAB
            </div>
        </div>
        <div className="days-active">
            <div>
                DOM
            </div>
        </div>
    </div>
}

export default Timetable;
